import { 
    configureStore 
} from '@reduxjs/toolkit'

import storage from 'redux-persist/lib/storage'

import { 
    combineReducers 
} from "redux"

import { 
    persistReducer,
    FLUSH,
    REHYDRATE,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER, 
} from 'redux-persist'

import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2'

// import slices

import appViewerReducer from './Slices/AppViewerSlice'
import forgotPasswordReducer from './Slices/ForgotPasswordSlice'
import signUpReducer from './Slices/SignUpSlice'
import logInReducer from './Slices/LogInSlice'
import accountConfirmReducer from './Slices/AccountConfirmSlice'
import userReducer from './Slices/UserSlice'
import resetPasswordReducer from './Slices/ResetPasswordSlice'
import hubReducer from './Slices/HubSlice'
import settingsReducer from './Slices/SettingsSlice'

const reducers = combineReducers({
    appViewer: appViewerReducer,
    forgotPassword: forgotPasswordReducer,
    signUp: signUpReducer,
    logIn: logInReducer,
    accountConfirm: accountConfirmReducer,
    user: userReducer,
    resetPassword: resetPasswordReducer,
    hub: hubReducer,
    settings: settingsReducer,
})

const persistConfig = {
    key: 'root',
    storage,
    stateReconciler: autoMergeLevel2,
    whitelist: ['user', 'appViewer', 'hub', 'settings']
}

const persistedReducer = persistReducer(persistConfig, reducers)

const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
                ignoredActionPaths: ['payload.user'],
            },
        }),
    //devTools: false,
})

export default store

